// extracted by mini-css-extract-plugin
module.exports = {"title":"JoinBackcellModal_title__oO5SN","modal":"JoinBackcellModal_modal__eeXA0","text":"JoinBackcellModal_text__PiKde","form":"JoinBackcellModal_form__sXskd"};